import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_12W_66_65_12W_20_79',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_12w_66_65_12w_20_79_usd',
		},
		primer: 'prd_6R3LiKgQX5MU',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 12,
		intro_period_type: 'week',
		next_period_value: 12,
		next_period_type: 'week',
	},
	trial: {
		days: 90,
		priceMap: {
			USD: 20.79,
		},
		originalPriceMap: {
			USD: 66.65,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 3,
		priceMap: {
			USD: 66.65,
		},
	},
}
